import TableRow from "@mui/material/TableRow";
import TableCell from "../../../../BillingAndPayments/components/TableCell";
import { expanderColumnSx, metricColumnSx } from "../columnWidths";
import { AD_GROUP } from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import { useFormContext } from "react-hook-form";
import { renderMetricValue } from "../../../../../utils/renderMetricValue";

const GoogleAppAdGroupRow = ({
  indexCampaign,
  indexAdGroup,
  adGroupID,
  data,
  columns,
}) => {
  const { campaign } = useFormContext();
  const { t } = useTranslationApp();

  const adsGroups = campaign.adsGroups || [];
  const foundAdGroup = adsGroups?.find((adGroup) => adGroup.id === adGroupID);

  return (
    <TableRow>
      <TableCell indexRow={indexCampaign} sx={expanderColumnSx} level={2} />
      {columns.map((col) => (
        <TableCell
          key={col.key}
          indexRow={indexCampaign}
          level={2}
          sx={metricColumnSx(col.width)}
        >
          {(() => {
            switch (col.key) {
              case "platform":
                return (
                  foundAdGroup?.name || `${t(AD_GROUP)} ${indexAdGroup + 1}`
                );
              case "spend":
                return renderMetricValue(data.spend, col.key, data.currency);
              case "impressions":
                return renderMetricValue(
                  data.impressions,
                  col.key,
                  data.currency
                );
              case "click":
                return renderMetricValue(data.click, col.key, data.currency);
              case "ctr":
                return renderMetricValue(data.ctr, col.key, data.currency);
              case "mainAction":
                return renderMetricValue(
                  data.mainAction,
                  col.key,
                  data.currency
                );
              case "costPerMainAction":
                return renderMetricValue(
                  data.costPerMainAction,
                  col.key,
                  data.currency
                );
              case "cpc":
                return renderMetricValue(
                  (data.cpc || 0).toFixed(2),
                  col.key,
                  data.currency
                );
              case "cpm":
                return renderMetricValue(
                  (data.cpm || 0).toFixed(2),
                  col.key,
                  data.currency
                );
              default:
                return renderMetricValue(
                  data[col.key],
                  col.key,
                  data.currency
                );
            }
          })()}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default GoogleAppAdGroupRow;
